export const ChatTourAnchor = {
  DRAWER_TOGGLE: "chat-drawer-toggle",
  HISTORY_ITEM: "chat-history-item",
  NEW_CONVERSATION: "chat-new-conversation",
  COMPOSER: "chat-composer"
} as const;
